import { useState } from "react";
import { Link } from "react-router-dom";

import "../Styles/Header.css";
import { BeatspotIcon } from "./icons/BeatspotIcon";
import { useAuth } from "../Services/AuthContext";
import DefaultAvatar from "./DefaultAvatar";
import HamburgerMenu from "./SubMenu/HamburgerMenu";
import {
  AudioLines,
  LayoutDashboard,
  Binoculars,
  Radio,
} from "lucide-react";
import { useIsMobile } from "../Hooks/useIsMobile";
import DropdownMenu from "./DropdownMenu";
import HeaderSearch from "./HeaderSearch";
import NotificationBell from "./Notifications/NotificationBell";

export default function Header() {
  const { isAuthenticated, user } = useAuth();
  console.log(user)

  const [isMenuActive, setIsMenuActive] = useState(false);

  const toggle = () => setIsMenuActive((v) => !v);
  const close = () => setIsMenuActive(false);
  const isMobile = useIsMobile();

  const isNavTabActive = (currentPath: String) => {
    if (currentPath === window.location.pathname) return true
    return false
  }
  const isContributor = user?.role === "CONTRIBUTOR"
  const isAdmin = user?.role === "ADMIN" || user?.role === "SUPERADMIN"
  return (
    <div className="header-wrapper">
      <Link to="/" className="logo-wrapper" aria-label="Beatspot home">
        <BeatspotIcon className="beatspot-logo-svg" size={140} color="ff3c7e" />
      </Link>

      {isAuthenticated &&
      <nav className="header-nav">
        <Link to="/" className="nav-item">
            <Binoculars className={isNavTabActive("/") ? "nav-icon active" : "nav-icon"} size={24} strokeWidth={1.9}></Binoculars>
            <span>
             Explore
            </span>
        </Link>
        <Link to="/feed" className="nav-item">
            <Radio className={isNavTabActive("/feed") ? "nav-icon active" : "nav-icon"} size={24} strokeWidth={1.9}></Radio>
            <span>
             Feed
            </span>
        </Link>
        {isContributor || isAdmin &&
        <Link to="/recognize" className="nav-item">
          <AudioLines className={isNavTabActive("/recognize") ? "nav-icon active" : "nav-icon"} size={24} strokeWidth={1.9}></AudioLines>
          <span>
          Recognize
          </span>
          </Link>
           }
           {isAdmin && 
        <Link to="/administrazione" className="nav-item">
        <LayoutDashboard className={isNavTabActive("/administrazione") ? "nav-icon active" : "nav-icon"} size={24} strokeWidth={1.9}></LayoutDashboard>
        <span>
          Dashboard
        </span>
          </Link>
          }
      </nav>
      }

      <div className="header-actions">
        <HeaderSearch canSearchPeople={isAuthenticated} />

        {isAuthenticated ? (
          <>
            <NotificationBell />

            <div
              className="avatar-menu-container"
            >
              <DefaultAvatar
                name={user?.firstName ?? user?.email ?? "User"}
                avatarUrl={user?.avatarUrl ?? undefined}
                onClick={toggle}
              />
            {isMobile ? (
              <HamburgerMenu
                name={user?.firstName ?? user?.email ?? "User"}
                isActive={isMenuActive}
                onClose={close}
              />
            ) : (
              isMenuActive && <DropdownMenu onNavigate={close} />
            )}
            </div>
          </>
        ) : (
          <Link to="/login" className="contributor-link">
            Contributor? Login here
          </Link>
        )}
      </div>
    </div>
  );
}
